import { render, staticRenderFns } from "./AdSlot.vue?vue&type=template&id=5359d235&"
import script from "./AdSlot.vue?vue&type=script&lang=ts&"
export * from "./AdSlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports